export enum Roles {
    MANAGER = 'manager',
    FOREMAN = 'foreman',
    PURCHASER = 'purchaser',
}
export interface ProjectUser {
    id: number;
    email: string;
    role: Roles;
    name: null | string;
    avatar: null | string;
}
export interface AddProjectContextProps {
    projectId: string;
    allProjectUsers: ProjectUser[];
    managers: {
        ids: number[];
        entities: Record<string, ProjectUser>;
    };
    foremans: {
        ids: number[];
        entities: Record<string, ProjectUser>;
    };
    purchases: {
        ids: number[];
        entities: Record<string, ProjectUser>;
    };
    setProjectsUsers: (project_users: {
        manager: ProjectUser[];
        foreman: ProjectUser[];
        purchase_agent: ProjectUser[];
    }) => void;
    deleteProjectUser: (id: number, role: string) => void;
    addProjectUser: (role: string, projectUser: ProjectUser) => void;
}
